import { ErrorCodes, Labels } from '../enums';
import type { ErrorDetails } from '../types';

export const TOKEN_REFRESH_ERROR: ErrorDetails = {
    key: 'REFRESH_TOKEN_EXPIRED',
    title: Labels.REFRESH_TOKEN_EXPIRED_LOGIN_REQUIRED,
    message: Labels.REFRESH_TOKEN_EXPIRED_REAUTHENTICATE,
    code: ErrorCodes.REFRESH_TOKEN_EXPIRED
};
